export enum ContractOfferType {
  agility = 'Agility',
  simplicity = 'Simplicity',
  hubBlocks = 'HubBlocks',
  flexAndShip = 'Flex&Ship',
  specials = 'Specials',
  indexed = 'Indexed',
  spot = 'Spot',
  average = 'Average',
  fixedPrice = 'Fixed price',
  clickPercent = 'Click %',
  clickMW = 'ClickMW',
  clickAndMatch = 'Click&Match',
  build = 'Build',
  buildAndEase = 'Build&Ease',
  buildAndOptimize = 'Build&Optimize',
  balancing = 'Balancing',
  blocSales = 'Bloc sales',
  misc = 'Misc.',
}
